<template><section>
<h1>Swiper 无缝轮播</h1>
<h2>基本用法</h2>
<p><span>传递的<strong>slideList</strong>类型为<strong>Array</strong>类型,每一个元素都含有<strong>imgSrc和clickUrl</strong>,即图片地址和跳转链接,默认大小宽度为100%,高度为300px,可以如下demo中重写<strong>style</strong>进行重置</span></p>
<demo-block>
                    <div class="source" slot="source"><nt-swiper :slideList="slideList" style="width:600px"></nt-swiper>


</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-swiper</span> <span class="hljs-attr">:slideList</span>=<span class="hljs-string">"slideList"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"width:600px"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-swiper</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    data() {
        <span class="hljs-keyword">return</span> {
            <span class="hljs-attr">slideList</span>: [
                {
                    <span class="hljs-attr">imgSrc</span>: <span class="hljs-built_in">require</span>(<span class="hljs-string">"../assets/imgs/img1.jpeg"</span>),
                    <span class="hljs-attr">clickUrl</span>: <span class="hljs-string">""</span>
                },
                {
                    <span class="hljs-attr">imgSrc</span>: <span class="hljs-built_in">require</span>(<span class="hljs-string">"../assets/imgs/img2.jpeg"</span>),
                    <span class="hljs-attr">clickUrl</span>: <span class="hljs-string">"http://baidu.com"</span>
                },
                {
                    <span class="hljs-attr">imgSrc</span>: <span class="hljs-built_in">require</span>(<span class="hljs-string">"../assets/imgs/img3.jpeg"</span>),
                    <span class="hljs-attr">clickUrl</span>: <span class="hljs-string">"http://baidu.com"</span>
                }
            ]
        }
    }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
</div></demo-block>
<h2>显示底部导航和左右箭头</h2>
<p><span><strong>showDots</strong>为Boolean类型,是否显示底部导航,<strong>showArrow</strong>为Boolean类型,是否显示左右箭头,<strong>duration</strong>为Number类型,轮播组件过渡值,单位为ms</span></p>
<demo-block>
                    <div class="source" slot="source"><nt-swiper :slideList="slideList" :showDots="true" :showArrow="true" :duration="3000" style="width:600px"></nt-swiper>


</div>
                    
                    <div class="highlight" slot="highlight"><pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">nt-swiper</span> <span class="hljs-attr">:slideList</span>=<span class="hljs-string">"slideList"</span> <span class="hljs-attr">:showDots</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">:showArrow</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">:duration</span>=<span class="hljs-string">"3000"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"width:600px"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">nt-swiper</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    data() {
        <span class="hljs-keyword">return</span> {
            <span class="hljs-attr">slideList</span>: [
                {
                    <span class="hljs-attr">imgSrc</span>: <span class="hljs-built_in">require</span>(<span class="hljs-string">"../assets/imgs/img1.jpeg"</span>),
                    <span class="hljs-attr">clickUrl</span>: <span class="hljs-string">"http://baidu.com"</span>
                },
                {
                    <span class="hljs-attr">imgSrc</span>: <span class="hljs-built_in">require</span>(<span class="hljs-string">"../assets/imgs/img2.jpeg"</span>),
                    <span class="hljs-attr">clickUrl</span>: <span class="hljs-string">"http://baidu.com"</span>
                },
                {
                    <span class="hljs-attr">imgSrc</span>: <span class="hljs-built_in">require</span>(<span class="hljs-string">"../assets/imgs/img3.jpeg"</span>),
                    <span class="hljs-attr">clickUrl</span>: <span class="hljs-string">"http://baidu.com"</span>
                }
            ]
        }
    }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
</div></demo-block>
<h3>Attributes</h3>
<table>
<thead>
<tr>
<th style="text-align:left">参数</th>
<th style="text-align:left">说明</th>
<th style="text-align:left">类型</th>
<th style="text-align:left">可选值</th>
<th style="text-align:left">默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td style="text-align:left">slideList</td>
<td style="text-align:left">含有<strong>imgSrc和clickUrl</strong>,即图片地址和跳转链接的数组</td>
<td style="text-align:left">Array</td>
<td style="text-align:left">-</td>
<td style="text-align:left">-</td>
</tr>
<tr>
<td style="text-align:left">showDots</td>
<td style="text-align:left">是否显示底部导航</td>
<td style="text-align:left">Boolean</td>
<td style="text-align:left"><code v-pre>true</code> <code v-pre>false</code></td>
<td style="text-align:left"><code v-pre>false</code></td>
</tr>
<tr>
<td style="text-align:left">showArrow</td>
<td style="text-align:left">是否显示左右箭头</td>
<td style="text-align:left">Boolean</td>
<td style="text-align:left"><code v-pre>true</code> <code v-pre>false</code></td>
<td style="text-align:left"><code v-pre>false</code></td>
</tr>
<tr>
<td style="text-align:left">duration</td>
<td style="text-align:left">轮播组件过渡值,单位为ms</td>
<td style="text-align:left">Number</td>
<td style="text-align:left">-</td>
<td style="text-align:left">2000</td>
</tr>
</tbody>
</table>
</section></template>

<script>
export default {
    data() {
        return {
            slideList: [
                {
                    imgSrc: require("../assets/imgs/img1.jpeg"),
                    clickUrl: "https://github.com/Z6T/nature-ui"
                },
                {
                    imgSrc: require("../assets/imgs/img2.jpeg"),
                    clickUrl: "https://github.com/Z6T/nature-ui"
                },
                {
                    imgSrc: require("../assets/imgs/img3.jpeg"),
                    clickUrl: "https://github.com/Z6T/nature-ui"
                }
            ]
        }
    }
}
</script>